// extracted by mini-css-extract-plugin
export default {"menuItem":"SideMenu_menuItem__oiOeR","isActive":"SideMenu_isActive__vsGO1","changePasswordLink":"SideMenu_changePasswordLink__sneQo"};